import Styles from './InternshipCertificate.module.scss';
import { useContext, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';
// Module imports.
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import FeatherIcon from 'feather-icons-react';
// Components import.
import { useAPI, Content, Message, AuthContext, useTranslation } from 'components/lib';
import { AivagamButton } from 'components/global/AivagamButton/AivagamButton';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';
import { InternshipCertificateGenerator } from 'components/global/InternshipCertificateGenerator/InternshipCertificateGenerator';

export function InternshipCertificate(props) {
    const { t } = useTranslation();
    const authContext = useContext(AuthContext);
    const { internship_cert_id } = useParams();
    const { data, loading } = useAPI(`/api/certificate/${internship_cert_id}`);
    const isLoading = loading || data === undefined;
    const certRef = useRef(null);
    const dateObj = new Date(data?.dateUnlocked);
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    const formattedDate = dateObj.toLocaleDateString('en-US', options);
    const certificateUrl = `${process.env.REACT_APP_URL}/internship/certificate/${internship_cert_id}`;
    const logoUrl = data?.orgLogo;

    const handleDownloadPDF = async () => {
        const element = certRef.current;
        if (!element) return;

        const canvas = await html2canvas(element, {
            scale: 2,
            useCORS: true,
        });

        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF({
            orientation: 'landscape',
            unit: 'mm',
            format: 'a4',
        });

        const imgWidth = 297;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        const imgX = 0;
        const imgY = (210 - imgHeight) / 2;

        pdf.addImage(imgData, 'PNG', imgX, imgY, imgWidth, imgHeight);
        pdf.save(`internship_certificate_${internship_cert_id}.pdf`);
    };

    return (
        <>
            <LoadingBackdrop isOpen={isLoading} />
            {!isLoading && data?.firstName ? (
                <div className={Styles.cert_container}>
                    <AivagamButton
                        icon
                        buttonText={
                            <>
                                <FeatherIcon color="white" icon="download" />
                                {t('InternshipPack.Certificate.button')}
                            </>
                        }
                        onClick={handleDownloadPDF}
                        type="confirm"
                    />

                    <InternshipCertificateGenerator
                        id="internshipCertContainer"
                        ref={certRef}
                        firstName={data.firstName}
                        lastName={data.lastName}
                        internshipName={data.certName}
                        issueDate={formattedDate}
                        internshipCertId={internship_cert_id}
                        logo={logoUrl}
                        qrCode={
                            <QRCodeSVG
                                bgColor="#004bb1"
                                fgColor="#FFFFFF"
                                value={certificateUrl}
                                size={100}
                            />
                        }
                    />
                </div>
            ) : null}

            {!isLoading && !data?.firstName && (
                <Content>
                    <Message
                        type="alert"
                        title={t('InternshipPack.Certificate.message.title')}
                        text={t('InternshipPack.Certificate.message.descr')}
                        buttonText={t('InternshipPack.Certificate.message.button')}
                        buttonLink={authContext?.user?.authenticated ? '/internships' : '/'}
                    />
                </Content>
            )}
        </>
    );
}